import createHttp from '@/config/http';
import type { Insurance, InsuranceGroup } from '@/types/patient';
import type { IResponseFetch, ResponseMetaData } from '@/types/service';

const http = createHttp(import.meta.env.VITE_PATIENT_URL);

// Re-export type
export type { Insurance };

// ========== INSURANCES ==========
export const getInsurances = async (
	page = 1,
	limit = 50,
	search = '',
	sort = '',
): Promise<{
	items: Insurance[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<IResponseFetch<Insurance>>('/insurances/ai', {
		params: {
			page,
			limit,
			search,
			// sort,
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getInsurancesGroups = async (): Promise<InsuranceGroup[]> => {
	const response = await http.get('/insurances/insurance-groups', {});
	return response.data.data
};

export const getInsurancesML = async (
	page: number,
	limit = 200,
	search: string,
	typeId?: string,
	topId?: string,
): Promise<{ name: string, id: string, score: number }[]> => {
	const response = await http.get('/insurances/ml', {
		params: {
			page,
			limit,
			search,
			typeId,
			topId
		}
	});
	return response.data;
};
